const {KitModule, registerModule} = window;

class TOC extends KitModule {
  constructor($element) {
    super($element);

    this.initialize();
  }

  bindEvents() {
    this.$toggleVisibility.addEventListener('click', this.handleToggleVisibility.bind(this));

    this.$contentHeadings?.forEach( ($heading) => {
      const options = {
        root: null,
        rootMargin: '0px',
        threshold: 0.1,
      };

      const observer = new IntersectionObserver( this.handleIntersect.bind(this), options);
      observer.observe($heading);
    });
  }

  bindUI() {
    if (this.contentSelector) {
      this.$content = document.querySelector(this.contentSelector);
      this.$contentHeadings = Array.from(this.$content?.querySelectorAll(':where(h2,h3)[id]'));
    }
  }

  handleIntersect(entries) {
    entries.forEach( (entry) => {
      const index = this.$contentHeadings.findIndex(($contentHeading) => $contentHeading === entry.target);

      if (entry.isIntersecting) {
        // If it's visible, we should consider it reached
        this.contentHeadingsReached[index] = entry.target;
      } else {
        // If it's not visible but it scrolled off the top of the screen, we
        // should consider it reached
        if (entry.boundingClientRect.top < 0) {
          this.contentHeadingsReached[index] = entry.target;
        } else {
          delete this.contentHeadingsReached[index];
        }
      }

      const currentIndex = this.contentHeadingsReached.findLastIndex(($contentHeading) => $contentHeading);
      this.currentIndex = currentIndex > -1 ? currentIndex : 0;
      this.updateUI();
    });
  }

  handleToggleVisibility() {
    this.isExpanded = !this.isExpanded;
    this.$toggleVisibility.setAttribute('aria-expanded', this.isExpanded);
  }

  initialize() {
    this.setVars();
    this.bindUI();
    this.bindEvents();
    this.updateUI();
  }

  setVars() {
    this.currentIndex = 0;
    this.contentHeadingsReached = [];
    this.contentSelector = this.$element.dataset.contentSelector;
    this.isExpanded = false;
  }

  updateUI() {
    this.$links.forEach(($link, index) => {
      if (index === this.currentIndex) {
        $link.setAttribute('aria-current', true);
      } else {
        $link.removeAttribute('aria-current');
      }
    });
  }

  unmount() {
    //
  }
}

registerModule('TOC', TOC);
